<template>
  <el-dialog
    title=""
    :visible="visible"
    :modal="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    v-bind="$attrs"
    class="c-dialog"
  >
    <div class="c-dialog-main">
      <div class="c-dialog-header">
        <div class="text">{{ title }}</div>
      </div>

      <div class="c-dialog-content">
        <slot name="content"></slot>
      </div>

      <div class="c-dialog-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>

      <i class="c-dialog-close el-icon-close icon" @click="close" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SDialog',
  props: {
    title: {
      required: true,
      type: String,
      default: ''
    },
    visible: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.c-dialog {
  >>> .el-dialog__header {
    display: none;
  }
}
.c-dialog-main {
  position: relative;
}
.c-dialog-header {
  margin-bottom: 20px;
  border-bottom: 1px solid #dcdcdc;

  .text {
    position: relative;
    width: fit-content;
    padding-bottom: 15px;
    color: #0062FF;

    &::after {
      content: ' ';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100%;
      height: 4px;
      border-radius: 4px;
      background-color: #0062FF;
    }
  }
}

.c-dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 35px;
}

.c-dialog-close {
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 2100;
  cursor: pointer;
  font-size: 18px;
  color: #909399;
  padding: 4px;
  line-height: 1;

  &:hover {
    color: #0062ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CDialog/index.vue